import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Instagram, Facebook, Youtube, Music2, Globe, Share2 } from "lucide-react";

const NETWORKS = [
  ["instagram", "Instagram", Instagram, "https://instagram.com/tuonome"],
  ["facebook", "Facebook", Facebook, "https://facebook.com/tuapagina"],
  ["tiktok", "TikTok", Music2, "https://tiktok.com/@tuonome"],
  ["youtube", "YouTube", Youtube, "https://youtube.com/@tuocanale"],
  ["website", "Sito web", Globe, "https://www.tuosito.it"],
];

export const SocialIcons = ({ socials }) => {
  const list = NETWORKS.filter(([k]) => socials?.[k]);
  if (!list.length) return null;
  return (
    <div className="flex flex-wrap gap-2 mt-4" data-testid="profile-socials">
      {list.map(([k, label, Icon]) => (
        <a key={k} href={socials[k]} target="_blank" rel="noreferrer noopener" data-testid={`social-${k}`} aria-label={label} title={label}
          className="w-10 h-10 rounded-full border border-slate-300 flex items-center justify-center text-navy hover:bg-gold hover:border-gold transition-colors"><Icon className="w-4 h-4"/></a>
      ))}
    </div>
  );
};

export const SocialLinksCard = () => {
  const { user, refresh } = useAuth();
  const [v, setV] = useState(user.socials || {});
  const save = async () => {
    try { await api.patch("/me", { socials: v }); toast.success("Social collegati al profilo"); refresh(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Errore nel salvataggio"); }
  };
  return (
    <div className="mt-8 card-premium p-6" data-testid="socials-card">
      <div className="flex items-center gap-2 mb-1"><Share2 className="w-5 h-5 text-gold"/><h3 className="font-display text-xl font-bold">I tuoi social</h3></div>
      <p className="text-sm text-slate-600 mb-4">Collega i tuoi profili: compariranno come icone nella tua scheda pubblica.</p>
      <div className="grid md:grid-cols-2 gap-3">
        {NETWORKS.map(([k, label, Icon, ph]) => (
          <label key={k} className="flex items-center gap-2 border border-slate-300 rounded-full px-4 py-2 focus-within:border-gold">
            <Icon className="w-4 h-4 text-gold shrink-0"/><span className="sr-only">{label}</span>
            <input data-testid={`social-input-${k}`} value={v[k] || ""} onChange={(e) => setV({ ...v, [k]: e.target.value.trim() })} placeholder={ph} className="flex-1 text-sm outline-none bg-transparent"/>
          </label>
        ))}
      </div>
      <div className="flex justify-end mt-3"><button data-testid="socials-save" onClick={save} className="btn-pill-gold text-sm">Salva social</button></div>
    </div>
  );
};
